import CARD_TYPES from './card-types-enum';
import GIFT_CARD_TYPES from './gift-card-types';

const cardRegex = {
  [CARD_TYPES.MASTER]: /^5[1-9][0-9]{14}$|^222[1-9][0-9]{12}$|^22[3-9][0-9]{13}$|^2[3-6][0-9]{14}$|^27[0-1][0-9]{13}$|^2720[0-9]{12}$/i,
  [CARD_TYPES.VISA]: /^4[0-9]{12}(?:[0-9]{3})?$/i,
  [CARD_TYPES.AMEX]: /^3[47][0-9]{13}$/i,
  [CARD_TYPES.CARNET]: /^506[1-4][0-9]{12}$/i,
  [CARD_TYPES.JCB]: /^3[5][0-9]{14}$/i,
  [GIFT_CARD_TYPES.UATP]: /^[0-9]{15}$/i,
  [CARD_TYPES.EMD_VOUCHER]: /^(139(0420|0421|0425|0426))[0-9]+$/i,
};

export default cardRegex;
